import React, { useEffect, useRef } from 'react';

export interface Task {
    id: number;
    name: string;
    start: Date;
    end: Date;
}

function GanttChart({ tasks }: { tasks: Task[] }) {
    const containerRef = useRef<HTMLTableElement>(null);
    const startDate = new Date(2024, 2, 1); // Example start date
    const endDate = new Date(2024, 2, 21); // Example end date
    const ticks = 7; // Number of ticks (days) in the header
    const NoOfColumns = (endDate.getDate() - startDate.getDate()) / ticks + 1;

    // Width of each day in pixels

    useEffect(() => {

        const container = containerRef.current;
        if (!container) return;

        // Clear existing content
        container.innerHTML = '';

        const dayWidth = (container.clientWidth - 100) / NoOfColumns / ticks;
        var widthOfColumn = dayWidth * ticks;
        const headerRow = createHeaderRow(startDate, endDate, ticks, widthOfColumn);
        container.appendChild(headerRow);
        // Example data
        tasks.forEach((task) => {
            const row = document.createElement('tr');

            // Add task name
            const nameCell = document.createElement('td');
            nameCell.textContent = task.name;
            nameCell.className = "task-name";
            row.appendChild(nameCell);

            // Calculate task duration in days
            const duration = Math.round((task.end.getTime() - task.start.getTime()) / (1000 * 60 * 60 * 24));

            // Calculate task start and end day indices
            const startDay = Math.round((task.start.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
            const endDay = startDay + duration;


            for (let i = 0; i < headerRow.childElementCount - 1; i++) {
                var td = document.createElement('td');

                row.appendChild(td);
            }

            // Calculate the start position of the task div

            const startCol = Math.floor(startDay / ticks);
            const tableLeftOffset = container.offsetLeft;

            const startPosition = 100 + (startCol * ticks * dayWidth) + ((startDay % ticks) * dayWidth) + tableLeftOffset;

            // Calculate the width of the task div
            const endCol = Math.ceil(endDay / ticks);
            const width = (endDay - startDay) * dayWidth;

            // Add task duration as div elements with background color
            const taskDiv = document.createElement('div');
            taskDiv.style.gridColumn = `${startCol} / span ${endCol - startCol}`;
            taskDiv.style.gridRow = `${row.rowIndex + 1}`;
            taskDiv.style.position = 'absolute';
            taskDiv.style.left = `${startPosition}px`;
            taskDiv.style.width = `${width}px`;
            taskDiv.style.height = '20px'; // Set height as needed
            taskDiv.style.backgroundColor = 'lightblue'; // Change color as needed
            taskDiv.style.border = '1px solid black';
            taskDiv.title = task.name + "start :" + task.start.getDate() + " , end: " + task.end.getDate();
            taskDiv.textContent = "Duration:" + (endDay - startDay);
            row.childNodes[startCol+1].appendChild(taskDiv);


            container.appendChild(row);
        });
    }, [tasks, startDate, endDate, ticks]);

    function createHeaderRow(startDate: Date, endDate: Date, ticks: number, widthOfColumn: number): HTMLTableRowElement {
        const headerRow = document.createElement('tr');

        // Add an empty cell for the task name column
        var td = document.createElement('td');
        td.className = "task-name";
        headerRow.appendChild(td);

        // Add date cells
        let currentDate = new Date(startDate);
        let dayIndex = 0;

        endDate.setDate(endDate.getDate() + ticks);
        while (currentDate <= endDate) {
            if (dayIndex % ticks == 0) {
                const dateCell = document.createElement('td'); // Use th for header cells
                dateCell.textContent = currentDate.toDateString(); // Display date in YYYY-MM-DD format
                dateCell.style.width = widthOfColumn + "px";
                headerRow.appendChild(dateCell);
            }

            // Move to the next day
            currentDate.setDate(currentDate.getDate() + 1);
            dayIndex++;
        }

        return headerRow;
    }

    return (
        <>
            Gantt
            <table ref={containerRef} width={"100%"} id="gantt-container"></table>
        </>
    );
}

export default GanttChart;
